export default defineNuxtPlugin(() => {
    
    addRouteMiddleware('guard-authenticated', () => {
        let isLoggedIn = true;
        if (!isLoggedIn) {
            return navigateTo('/')
        }
    });

})